import './gazetteer-info-panel.css';
import h from 'hyperscript';

import i18n from './messages.properties';

const NAME = 'd-gazetteer-info-panel';

export class GazetteerInfoPanel extends HTMLElement {

  constructor (address, attributes) {
    super();
    this.append(
      h('details.d-panel-section.d-gazetteer-info-panel--address',
        { open: true },
        h('summary', i18n('infoPanel.address')),
        address
      ),
      h('details.d-panel-section',
        { open: true },
        h('summary', i18n('infoPanel.attributes')),
        createAttributeTable(attributes)
      )
    );
  }

}

function createAttributeTable (attributes) {
  const trs = Object.entries(attributes).map(([ key, value ]) =>
    h('tr',
      h('td.d-gazetteer-info-panel--attribute-name', key),
      h('td', value)
    )
  );

  return h('table.d-gazetteer-info-panel--attribute-table',
    h('tbody', trs)
  );
}

customElements.define(NAME, GazetteerInfoPanel);
